module.exports = __webpack_public_path__ + "static/img/loginCk.84180153.png";